import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { GlobalCtx } from '../../context/GlobalContext';
import { PetitionPageCtx } from '../../context/PetitionContext';
import { LastFiveList, Ribbon } from '../../styledComponents/LastFiveSignersList.styled';
import ElapsedTime from '../../components/LastFiveSigners/ElapsedTime';

const LastFiveSignersList = () => {
  const { lastFiveSigners, countries } = useContext(PetitionPageCtx);
  const nodeRefs = useRef([]);
  const { lang } = useContext(GlobalCtx);
  const { t } = useTranslation();

  return (
    <LastFiveList>
      <Ribbon lang={lang} >
        <p>{t('recent_signers')}</p>
      </Ribbon>
      <TransitionGroup component={null}>
        {lastFiveSigners.map((signer, index) => {
          const country = countries.find(
            (country) => country?.code === signer?.country?.toUpperCase()
          );

          const firstNameUppercase = signer?.first_name?.charAt(0).toUpperCase() + signer?.first_name?.slice(1);

          const countryFlag = (flag) => {
            if(flag === 'UK') {
              return 'gb';
            } else if(flag === "Italia") {
              return 'it';
            }
            return flag?.toLowerCase();
          };

          return (
            <CSSTransition
              key={signer.created}
              timeout={500}
              classNames="signer"
              nodeRef={nodeRefs.current[index]}
            >
              <li ref={nodeRefs.current[index]} >
                <ElapsedTime created={signer.created} />
                <div>
                  <img
                    loading="lazy"
                    src={`https://flagcdn.com/w20/${countryFlag(signer?.country)}.png`}
                    srcSet={`https://flagcdn.com/w40/${countryFlag(signer?.country)}.png 2x`}
                    alt={`${country?.name} flag`}
                  />
                  <p className="user_box">
                    <span className="user_name">
                      {firstNameUppercase} {signer?.last_name_initial?.toUpperCase()}.{' '}
                    </span>
                    <span className="user_country">{country?.name?.length > 29 ? `${country?.name?.slice(0, 29)}...` : country?.name}</span>
                  </p>
                </div>
              </li>
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </LastFiveList>
  );
};

export default LastFiveSignersList;
